import { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchRecommendations } from 'Redux/ducks/recommendations';
import RecommendedProductsContext from 'Components/Product/Context/recommended-products-context';

const useProductRecommendations = ({
  forceTopSellers,
  forceBundle,
  forceBundleType,
  cachedHits,
}) => {
  const [topSellers, setTopSellers] = useState([]);
  const [recommendationsHits, setRecommendationsHits] = useState([]);
  const dispatch = useDispatch();
  const items = useSelector(state => state?.cart?.items);
  const productContext = useContext(RecommendedProductsContext);


  useEffect(() => {
    const fetchTopSellers = async () => {
      const results = await dispatch(
        fetchRecommendations('cart', null, items, null, 14, cachedHits),
      );

      setTopSellers(results);
    };

    const fetchBundleRecommendations = async () => {
      const mainResults = await dispatch(fetchRecommendations('bundle', null, items, null, 14, cachedHits));

      let combinedResults = mainResults;

      // If this is a software or book bundle we want to also fetch those results and the game bundle results
      // that if there are no software/book bundles to recommend we can still show the game bundle recommendations
      if (forceBundleType === 'book' || forceBundleType === 'software') {
        const additionalResults = await dispatch(fetchRecommendations(`${forceBundleType}-bundle`, null, items, null, 14, cachedHits));
        combinedResults = combinedResults.concat(additionalResults);
      }

      setRecommendationsHits(combinedResults);
    };


    if (forceTopSellers) {
      fetchTopSellers();
    } else if (forceBundle) {
      fetchBundleRecommendations();
    }
  }, [forceTopSellers, forceBundle, forceBundleType, items, cachedHits, dispatch]);

  const hits = productContext?.length ? productContext : recommendationsHits;

  const filteredHits = (forceTopSellers ? topSellers : hits).filter(hit => hit.type !== 'dlc');

  return {
    hits: filteredHits,
  };
};

export default useProductRecommendations;
